export enum SubmitButtonType {
    primary = 'primary',
    primarySmall = 'primary-small',
}
